import { authenticatedInstance } from 'api';

export const GET_API_KEYS = {
  STARTED: 'GET_API_KEYS_STARTED',
  SUCCESS: 'GET_API_KEYS_SUCCESS',
  FAIL: 'GET_API_KEYS_FAIL',
};

export const DELETE_API_KEY = {
  STARTED: 'DELETE_API_KEY_STARTED',
  SUCCESS: 'DELETE_API_KEY_SUCCESS',
  FAIL: 'DELETE_API_KEY_FAIL',
};

const API_ENDPOINTS = {
  LIST_API_KEYS: '/api/ListApiKey',
  DELETE_API_KEY: '/api/DeleteApiKey',
};

const fetchApiData = (url, data, successType, failType) => {
  return async (dispatch) => {
    dispatch({ type: successType.STARTED });

    try {
      const response = await authenticatedInstance({
        url,
        method: 'POST',
        data,
      });

      const { data: responseData } = response;

      if (responseData.status === 'Success') {
        dispatch({
          type: successType.SUCCESS,
          payload: responseData.data,
        });
      } else {
        dispatch({ type: failType });
        // dispatch(triggerToast(responseData.message || 'somethingWentWrong'));
      }
    } catch (e) {
      dispatch({ type: failType });
      // dispatch(triggerToast('somethingWentWrong'));
    }
  };
};

export const loadApiKeys = (keyType) => fetchApiData(API_ENDPOINTS.LIST_API_KEYS, { keyType }, GET_API_KEYS, GET_API_KEYS.FAIL);

export const deleteApiKey = (key, cb) =>
  fetchApiData(API_ENDPOINTS.DELETE_API_KEY, { key }, DELETE_API_KEY, DELETE_API_KEY.FAIL).then(() => {
    cb();
  });
